import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import TermsCondition from "./component/TermsCondition";
import PrivacyPolicy from "./component/PrivacyPolicy";
import Eula from "./component/Eula";
import Disclaimer from "./component/Disclaimer";
import DeletionRequest from "./pages/DeletionRequest";

const Router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/account-deletion-request", element: <DeletionRequest /> },
  { path: "/terms-condition", element: <TermsCondition /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/eula", element: <Eula /> },
  { path: "/disclaimer", element: <Disclaimer /> },
]);

function App() {
  return (
    <>
      <RouterProvider router={Router} />
    </>
  );
}

export default App;
